import FilterDrawer from 'components/InstructorSubmissions/FilterDrawer';
import ConfirmPushGradesDialog from 'components/InstructorViewAssignment/ConfirmPushGradesDialog';
import { useViewport } from 'contexts/viewport';
import Desktop from 'pages/QuizSubmissions/desktop';
import Mobile from 'pages/QuizSubmissions/mobile';
import { PageContext } from 'pages/QuizSubmissions/PageProvider';
import Tablet from 'pages/QuizSubmissions/tablet';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Redirect } from 'react-router-dom';
import { Button, Loading, Stack, Text } from 'shell/components';
import { QuizSubmissionStatus } from 'utils/quizSubmissionList';

const layouts = { desktop: Desktop, tablet: Tablet, mobile: Mobile };

const PageLayout = () => {
    const { device } = useViewport();
    const { t } = useTranslation('quiz');
    const context = useContext(PageContext);
    const { quiz, submissions, loadFailed, load, columns, sortState, handleSetSortState } = context;

    if (loadFailed)
        return (
            <Stack alignItems={'center'} spacing={4} sx={{ p: 6 }}>
                <Text role={'alert'}>
                    {t('grading.load-error', 'Quiz submissions could not be loaded. Please try again.')}
                </Text>
                <Button onClick={load}>{t('common:controls.retry', 'Retry')}</Button>
            </Stack>
        );
    if (!quiz || !submissions) return <Loading />;
    if (!submissions.length) return <Redirect to={`/quizzes/${quiz.id}`} />;

    const Layout = layouts[device];
    const statusOptions = [
        { value: QuizSubmissionStatus.READY, label: t('common:status.ready-for-review', 'Ready for review') },
        { value: QuizSubmissionStatus.IN_PROGRESS, label: t('common:status.partially-reviewed', 'Partially reviewed') },
        { value: QuizSubmissionStatus.REVIEWED, label: t('common:status.reviewed', 'Reviewed') },
        { value: QuizSubmissionStatus.FAILED, label: t('common:status.failed-to-process', 'Failed to process') },
        { value: QuizSubmissionStatus.PROCESSING, label: t('common:ui.processing', 'Processing') },
    ];

    return (
        <>
            <Layout {...context} />
            {context.pushSubmissionIds && (
                <ConfirmPushGradesDialog
                    key={quiz.id}
                    open
                    assignment={quiz}
                    course={context.course}
                    submissions={submissions.filter(({ id }) => context.pushSubmissionIds.includes(id))}
                    onClose={context.closePushDialog}
                    onPushed={context.onPushed}
                />
            )}
            <FilterDrawer
                columns={columns}
                sortState={sortState}
                handleSetSortState={handleSetSortState}
                filterContext={{ ...context, assignment: quiz }}
                statusOptions={statusOptions}
            />
        </>
    );
};

export default PageLayout;
